var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTvR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1121_23369",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1121_23369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.19844 18.0001C3.70344 18.0001 3.27969 17.8238 2.92719 17.4711C2.57469 17.1184 2.39844 16.6944 2.39844 16.1991V5.3931C2.39844 4.89776 2.57469 4.4751 2.92719 4.1251C3.27969 3.7751 3.70344 3.6001 4.19844 3.6001H19.7984C20.2934 3.6001 20.7172 3.77643 21.0697 4.1291C21.4222 4.48176 21.5984 4.90576 21.5984 5.4011V16.2071C21.5984 16.7024 21.4222 17.1251 21.0697 17.4751C20.7172 17.8251 20.2934 18.0001 19.7984 18.0001H15.5984V19.5001C15.5984 19.7551 15.5123 19.9688 15.3399 20.1413C15.1676 20.3138 14.9541 20.4001 14.6994 20.4001H9.30544C9.05077 20.4001 8.83594 20.3138 8.66094 20.1413C8.48594 19.9688 8.39844 19.7551 8.39844 19.5001V18.0001H4.19844ZM4.19844 16.2001H19.7984V5.4001H4.19844V16.2001Z",
    fill: "#d3135a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvR);
export default __webpack_public_path__ + "static/media/tv_r.f4ff71c2b96c546ddd5fe0916ffeb2f7.svg";
export { ForwardRef as ReactComponent };